/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchRunResultArtifactsStatementsInner } from './BatchRunResultArtifactsStatementsInner';
import {
    BatchRunResultArtifactsStatementsInnerFromJSON,
    BatchRunResultArtifactsStatementsInnerFromJSONTyped,
    BatchRunResultArtifactsStatementsInnerToJSON,
    BatchRunResultArtifactsStatementsInnerToJSONTyped,
} from './BatchRunResultArtifactsStatementsInner';
import type { BatchRunResultArtifactsReportCsv } from './BatchRunResultArtifactsReportCsv';
import {
    BatchRunResultArtifactsReportCsvFromJSON,
    BatchRunResultArtifactsReportCsvFromJSONTyped,
    BatchRunResultArtifactsReportCsvToJSON,
    BatchRunResultArtifactsReportCsvToJSONTyped,
} from './BatchRunResultArtifactsReportCsv';

/**
 * 
 * @export
 * @interface BatchRunResultArtifacts
 */
export interface BatchRunResultArtifacts {
    /**
     * 
     * @type {BatchRunResultArtifactsReportCsv}
     * @memberof BatchRunResultArtifacts
     */
    reportCsv: BatchRunResultArtifactsReportCsv;
    /**
     * 
     * @type {BatchRunResultArtifactsReportCsv}
     * @memberof BatchRunResultArtifacts
     */
    orderDetailReportCsv: BatchRunResultArtifactsReportCsv;
    /**
     * 
     * @type {Array<BatchRunResultArtifactsStatementsInner>}
     * @memberof BatchRunResultArtifacts
     */
    statements: Array<BatchRunResultArtifactsStatementsInner>;
}

/**
 * Check if a given object implements the BatchRunResultArtifacts interface.
 */
export function instanceOfBatchRunResultArtifacts(value: object): value is BatchRunResultArtifacts {
    if (!('reportCsv' in value) || value['reportCsv'] === undefined) return false;
    if (!('orderDetailReportCsv' in value) || value['orderDetailReportCsv'] === undefined) return false;
    if (!('statements' in value) || value['statements'] === undefined) return false;
    return true;
}

export function BatchRunResultArtifactsFromJSON(json: any): BatchRunResultArtifacts {
    return BatchRunResultArtifactsFromJSONTyped(json, false);
}

export function BatchRunResultArtifactsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultArtifacts {
    if (json == null) {
        return json;
    }
    return {
        
        'reportCsv': BatchRunResultArtifactsReportCsvFromJSON(json['report_csv']),
        'orderDetailReportCsv': BatchRunResultArtifactsReportCsvFromJSON(json['order_detail_report_csv']),
        'statements': ((json['statements'] as Array<any>).map(BatchRunResultArtifactsStatementsInnerFromJSON)),
    };
}

export function BatchRunResultArtifactsToJSON(json: any): BatchRunResultArtifacts {
    return BatchRunResultArtifactsToJSONTyped(json, false);
}

export function BatchRunResultArtifactsToJSONTyped(value?: BatchRunResultArtifacts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'report_csv': BatchRunResultArtifactsReportCsvToJSON(value['reportCsv']),
        'order_detail_report_csv': BatchRunResultArtifactsReportCsvToJSON(value['orderDetailReportCsv']),
        'statements': ((value['statements'] as Array<any>).map(BatchRunResultArtifactsStatementsInnerToJSON)),
    };
}

